<script>
  import { Row, Column, Block, Text, TextInput, CheckBox, Image, Popup, Icon, Link } from 'bastone'
  import { colors } from '../consts'
  import MyButton from '../components/button.svelte'
  import BotCard from '../components/botcard.svelte'
  import { User, ApiClient, ChatBot } from '../models'
  import { isDesktop, Context, isLoggedIn, screenWidth } from '../context'
  import { onDestroy, onMount } from 'svelte'

  let showLogin = false
  let autoRegister = true
  let useSms = false
  let mobile = ''
  let verifyCode = ''
  let password = ''
  let mobileRe = new RegExp('^\\+?(86)?1\\d{10}$')
  let verifyCodeRe = new RegExp('^\\d{4}$')
  let errorMessage = ''
  let sendCountDown = 0
  let inviteCode = ''
  let hotBots = []
  let contentWidth = '80%'
  let bindBodyWidth = undefined

  async function sendCode() {
    if (sendCountDown > 0)
      return

    if (!mobileRe.test(mobile)) {
      errorMessage = '请输入有效的手机号'
      return
    }
    errorMessage = ''
    sendCountDown = 60
    let timer = setInterval(() => {
      sendCountDown--
      if (sendCountDown <= 0) clearInterval(timer)
    }, 1000)
    ApiClient.sendCode(mobile)
  }

  async function userLogin() {
    if (!mobileRe.test(mobile)) {
      errorMessage = '请输入有效的手机号'
      return
    }

    if (!useSms && password == '') {
      errorMessage = '请输入密码'
      return
    }

    if ((useSms || autoRegister) && !verifyCodeRe.test(verifyCode)) {
      errorMessage = '请输入有效的验证码'
      return
    }

    errorMessage = ''
    let user = null
    if (autoRegister) {
      user = await User.register(mobile, verifyCode, password, inviteCode)
    } else {
      if (useSms) user = await User.login(mobile, verifyCode, '')
      else user = await User.login(mobile, '', password)
    }
    if (user != null) {
      Context.setUser(user)
      location.href = '/home'
    } else {
      errorMessage = '登陆失败'
    }
  }

  const unsubscribe = screenWidth.subscribe((winWidth) => {
    if (winWidth > 1920) {
      contentWidth = '70%'
    } else if (winWidth > 1600) {
      contentWidth = '80%'
    } else if (winWidth > 1024) {
      contentWidth = '82%'
    } else if (winWidth > 768) {
      contentWidth = '90%'
    } else {
      contentWidth = '94%'
    } 
  })
  onDestroy(unsubscribe)

  onMount(async () => {
    let queryParams = new URLSearchParams(window.location.search)
    let token = queryParams.get('token') || ''
    if (token) {
      Context.setToken(token)
      location.href = '/home'
    }

    inviteCode = queryParams.get('u') || ''
    inviteCode = parseInt(inviteCode.trim())
    if (inviteCode) {
      autoRegister = true
      //showLogin = true
    }
    hotBots = await ChatBot.getHot(20)
  })
</script>

<svelte:head>
  <title>首页 - Deeppp新一代AI驱动企业级BOT平台 - 火原科技产品</title>
</svelte:head>


<Popup name=login bind:showing={showLogin} center={true} backgroundColor={colors.translucent} clickDismiss={false}>
  <Block width=22rem backgroundColor=white padding=1.5rem>
    <Column width=100%>
      <Row width=100%>
        <Row expand=1 align=center>
          <Block width=1.5rem/>
          <Block 
            height=2.7rem width=3rem bottomBorder=3 borderColor={autoRegister?'black':'white'} textAlign=center
            on:click={()=>autoRegister=true}
          >
            <Text lineHeight=2.7rem size=1.4rem bold={autoRegister}>注册</Text>
          </Block>
          <Block width=2rem/>
          <Block 
            height=2.7rem width=3rem bottomBorder=3 borderColor={!autoRegister?'black':'white'} textAlign=center
            on:click={()=>autoRegister=false}
          >
            <Text lineHeight=2.7rem size=1.4rem bold={!autoRegister}>登陆</Text>
          </Block>
        </Row>
        <Block on:click={()=>{showLogin=false}} cursor=pointer><Icon name=close size=30/></Block>
      </Row>
      <Block height=30/>
      <TextInput 
        icon=mobile-phone border=2 borderColor={colors.black} iconSize=1.4rem space=0.4rem
        height=3rem width=100% fontSize=1.2rem placeholder=手机号 placeholderColor={colors.lightGray}
        bind:value={mobile}
      />

      {#if useSms || autoRegister}
      <Block height=0.8rem/>
      <Row width=100%>
        <TextInput 
          icon=security border=2 borderColor={colors.black} iconSize=1.4rem space=0.4rem
          height=3rem width=68% fontSize=1.2rem placeholder=短信验证码 placeholderColor={colors.lightGray}
          bind:value={verifyCode}
        /><MyButton 
          height=3rem width=32% leftBorder=0 fontSize=1rem bold={false} on:click={sendCode}
        >{sendCountDown>0?sendCountDown+'s':'发送短信'}</MyButton>
      </Row>
      {/if}

      {#if !useSms || autoRegister}
      <Block height=0.8rem/>
      <TextInput 
        icon=lock border=2 borderColor={colors.black} iconSize=1.4rem space=0.4rem isPassword={true}
        height=3rem width=100% fontSize=1.2rem placeholder=密码 placeholderColor={colors.lightGray}
        bind:value={password} on:keypress={(e)=>{if(e.keyCode==13){e.preventDefault();userLogin()}}}
      />
      {/if}

      {#if errorMessage}
      <Block height=0.8rem/>
      <Text color=red size=1rem>{errorMessage}</Text>
      {/if}

      {#if !autoRegister}
      <Block height=0.8rem/>
      <CheckBox 
        iconColor={colors.black} size=1rem border=2 borderColor={colors.lightGray} space=0.4rem
        bind:checked={useSms}
      >
        <Text size=1rem lineHeight=1.3rem color={colors.gray}>短信登陆</Text>
      </CheckBox>
      {/if}
      <Block height=1.2rem/>
      <MyButton width=100% height=3rem fontSize=1rem fill=1 bold=1 on:click={userLogin}>立即使用</MyButton>
      <Block height=0.5rem/>
    </Column>
  </Block>
</Popup>


<Row height=100% align=center>
<Column width={contentWidth}>

  <Row height=7.5rem xAlign=center>
    <Image height=3.2rem url='/images/logo.png'/>
    <Block expand=1/>
    <MyButton 
      width=7.5rem height=2.5rem fontSize=1rem bold=1
      on:click={()=>{if($isLoggedIn){location.href='/home'}else{showLogin=true}}}
    >{$isLoggedIn?'进入平台':'登陆/注册'}</MyButton>
    {#if $isDesktop}
    <Block width=1rem/>
    {/if}
  </Row>

  <Column expand=1 basis=0>
    <Block height=1rem/>
    <Block>
      <Row height=100% align=center>
        <Column width={$isDesktop?'55%':'100%'}>
          <Block width=100%>
            <Text 
              size={$screenWidth>=1200?'1.8rem':'1.6rem'} 
              lineHeight={$screenWidth>=1200?'3.4rem':'2.8rem'} wrap=1
            >新一代AI技术驱动IM-BOT企业级平台，一起创建共享各类功能强大的专业BOT，让每个人汲取AI的力量强化自身</Text>
          </Block>
          
          <Block height=1rem/>
          <Block>
            <Text size=1.3rem lineHeight=2rem wrap=1>免费创建专属BOT，支持私有数据集/知识库</Text>
          </Block>
          <Block height={$isDesktop?'2rem':'1rem'}/>
          
          <Row>
            <MyButton 
              height=3rem width=9rem fontSize=1.1rem fill={true} icon=operation iconSize=1.2rem
              on:click={()=>{if($isLoggedIn){location.href=`/home`}else{showLogin=true}}}
            >立刻创建</MyButton>
          </Row>
          {#if $screenWidth >= 1200}
          <Block height=8rem/>
          {/if}
        </Column>
        {#if $isDesktop}
        <Block width=2rem/>
        <Block width=45%>
          <Image url='./images/girl.jpg' width=100%></Image>
        </Block>
        <Block width=2rem/>
        {/if}
      </Row>
    </Block>

    <Block height=1.5rem/>
    <Row height=2.5rem>
      <Text size=1.3rem>热门BOT推荐</Text>
    </Row>
    <Block height=0.8rem width=100% bindSize=1 bind:clientWidth={bindBodyWidth}/>
    <Row wrap=1>
      {#each hotBots as bot}
      <BotCard 
        bot={bot} showTag={false} bind:parentWidth={bindBodyWidth} 
        clickFunc={()=>{if($isLoggedIn){location.href=`/chat?bot_id=${bot.id}`}else{showLogin=true}}}
      />
      {/each}
    </Row>
    <Block height=2rem/>
    <Text size=1rem>Copyright &copy; 2023 DEEPPP <Link url='https://beian.miit.gov.cn'>京ICP备16051844号-2</Link></Text>
    <Block height=2rem/>

  </Column>
  
</Column>
</Row>
